const red = {
  300: "#f55d86",
  500: "rgb(204, 62, 100)",
  700: "#a33150",
};

export default red;
